import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useDewasPekerjaanListModel} from "@/stores/models/dewas-pekerjaan-list-model";

export const useDewasPekerjaanListStore  = defineStore(
    'dewasPekerjaanListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceDewasPekerjaanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasPekerjaanListModel().dewasPekerjaanListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePekerjaanList = (additionalParams = null) => {
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePekerjaanListModel().pekerjaanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceDewasPekerjaanList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceDewasPekerjaanList.value.reload();
        };

        return {
            dataSourceDewasPekerjaanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);